import x from './HuntEnd';

export default x;
